import { captureException } from "@sentry/browser";
import { AxiosInstance, AxiosResponse } from "axios";
import { Dispatch } from "redux";
import { IPlan } from "../../../../common/types";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { PackActionTypes } from "../models/packActions";

import { DUPLICATE_PRIVATE_PLAN } from "../types";

interface IDuplicatePrivatePlanResponse {
    plan?: IPlan, limit?: number
}

export default (data: { planId: string, packId: string }, callback: (res: AxiosResponse<IDuplicatePrivatePlanResponse>) => void) => 
    async (dispatch: Dispatch<PackActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<IDuplicatePrivatePlanResponse>("/duplicate-private-plan", data);
        dispatch({
            type: DUPLICATE_PRIVATE_PLAN,
            payload: res,
        });
        callback(res);
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};
